import DocumentReferences from './DocumentReferences'

export default DocumentReferences
